module.exports = __webpack_public_path__ + "static/img/operations04.76b64ac.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/operations04.png
// module id = l20z
// module chunks = 0